import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MenuItemWithClaims } from './layout.model';
import { MenuService } from './services/menu.service';

@Component({
  selector: 'app-breadcrumb',
  template: `<p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>`
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  public items: MenuItemWithClaims[] = [];
  public home: MenuItem;

  private readonly breadcrumbSubscription: Subscription;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly menuService: MenuService,
    private readonly router: Router
  ) {
    this.home = { icon: 'fa fa-home', routerLink: '/', routerLinkActiveOptions: { exact: true } };
    this.breadcrumbSubscription = this.menuService.breadcrumbAdded$.subscribe(i => {
      if (i) {
        this.items.push(i)
        this.items = [...this.items];
      } else {
        this.items = [];
      }
    });
  }

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.items = this.getBreadcrumbs(this.activatedRoute.root);
    });

  }

  ngOnDestroy(): void {
    this.breadcrumbSubscription.unsubscribe();
  }

  private getBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

    const children = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      if (!Object.prototype.hasOwnProperty.call(child.snapshot.data, ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
      url += `/${routeURL}`;

      const breadcrumb: MenuItem = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB] as string,
        routerLink: url,
        routerLinkActiveOptions: { exact: true }
      };

      breadcrumbs.push(breadcrumb);

      return this.getBreadcrumbs(child, url, breadcrumbs);
    }

    return [];
  }
}
